<template>
  <el-select
    filterable
    :clearable="clearable"
    default-first-option
    :filter-method="filterMethod"
    @focus="focusBrand"
    @change="changeBrand"
    :size="size"
    :value="value"
    style="width: 100%"
    :placeholder="placeholder"
    :multiple="multiple"
    :collapse-tags="collapseTags"
    :disabled="disabled"
  >
    <el-option
      v-for="item in brandList"
      :key="item.value"
      :value="item.value"
      :label="item.label"
      :disabled="item.disabled"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: "BrandSelect",
  props: {
    size: String,
    value: [String, Number, Array],
    data: {
      type: Array,
      required: true,
    },
    placeholder: String,
    clearable: Boolean,
    multiple: Boolean,
    collapseTags: Boolean,
    disabledIds: Array,
    disabled: Boolean,
  },
  data() {
    return {
      brandList: [],
    };
  },
  watch: {
    data(list) {
      this.init(list);
    },
    value(val) {
      let brandList = this.data.slice(0, 200);
      if (this.multiple && val) {
        brandList = brandList.concat(
          val.map((v) => {
            return this.data.filter((item) => {
              if (item.value === v) {
                return true;
              }
              return false;
            })[0];
          })
        );
      } else {
        brandList = brandList.concat(
          this.data.filter((item) => {
            if (item.value === val) {
              return true;
            }
            return false;
          })
        );
      }
      this.brandList = this.checkDisabled(brandList);
    },
  },
  mounted() {
    this.init(this.data);
  },
  methods: {
    init(list) {
      let brandList = list.slice(0, 200);
      if (this.multiple && this.value) {
        brandList = brandList.concat(
          this.value.map((val) => {
            return list.filter((item) => {
              if (item.value === val) {
                return true;
              }
              return false;
            })[0];
          })
        );
      } else {
        brandList = brandList.concat(
          list.filter((item) => {
            if (item.value === this.value) {
              return true;
            }
            return false;
          })
        );
      }
      this.brandList = this.checkDisabled(brandList);
    },
    changeBrand(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },
    filterMethod(query) {
      if (query) {
        const data = [];
        this.data.filter((item) => {
          const name = `${item.label}`.toUpperCase();
          const str = query.toUpperCase();
          // if (name.startsWith(str) && data.length < 200) {
          if (name.indexOf(str) >= 0 && data.length < 200) {
            data.push(item);
            return true;
          }
          return false;
        });
        this.brandList = this.checkDisabled(data);
      } else {
        this.brandList = this.checkDisabled(this.data.slice(0, 200));
      }
    },
    focusBrand() {
      this.brandList = this.checkDisabled(this.data.slice(0, 200));
    },
    checkDisabled(list) {
      return list.map(item => ({
        ...item,
        disabled: this.disabledIds ? this.disabledIds.indexOf(item.value) > -1 : false,
      }))
    },
  },
};
</script>